import { ChangeDetectionStrategy, Component, inject, input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { map, merge, Observable, startWith } from "rxjs";

import { BannerModule, HeaderComponent } from "@bitwarden/components";

import { SharedModule } from "../../shared";
import { ProductSwitcherModule } from "../product-switcher/product-switcher.module";

import { AccountMenuComponent } from "./account-menu.component";

type HeaderRouteData = {
  titleId?: string;
  backRouterLink?: string | readonly string[];
};

@Component({
  selector: "app-header",
  templateUrl: "./web-header.component.html",
  imports: [
    SharedModule,
    ProductSwitcherModule,
    BannerModule,
    HeaderComponent,
    AccountMenuComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebHeaderComponent {
  private readonly route = inject(ActivatedRoute);

  /**
   * Custom title that overrides the route data `titleId`
   */
  readonly title = input<string>();

  /**
   * Icon to show before the title
   */
  readonly icon = input<string>();

  /**
   * Route for a back link shown before the title
   */
  readonly backRouterLink = input<string | readonly string[]>();

  protected readonly routeData$: Observable<HeaderRouteData> = merge(
    ...this.route.pathFromRoot.map((route) => route.data),
  ).pipe(
    map(() => this.resolveHeaderRouteData()),
    startWith(this.resolveHeaderRouteData()),
  );

  private resolveHeaderRouteData(): HeaderRouteData {
    const routes = this.route.pathFromRoot;

    for (let i = routes.length - 1; i >= 0; i--) {
      const data = routes[i].snapshot.data as HeaderRouteData;

      if (data.titleId != null || data.backRouterLink != null) {
        return {
          titleId: data.titleId,
          backRouterLink: data.backRouterLink,
        };
      }
    }

    return {};
  }
}
